import { render, staticRenderFns } from "./OperatorOperatorConfig.vue?vue&type=template&id=47a9d4aa"
import script from "./OperatorOperatorConfig.vue?vue&type=script&lang=js"
export * from "./OperatorOperatorConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports